import Cmp from './Footer.js'
import Connected from './Footer.connected.js'
export { Connected as default, Cmp }
